module.exports = "https://images.shiksha.ws/saassets/media/applyBanner_icon.18536e6a.svg";